export const renderComponent = {
  data() {
    return {
      renderedComponent: true
    }
  },
  methods: {
    renderComponent() {
      this.renderedComponent = false;

      this.$nextTick(() => {
        this.renderedComponent = true;
      });
    }
  }
};